module.exports = __webpack_public_path__ + "static/media/progress_auswahl.064e240e.svg";